// ─── HealthCues Support Team — single source of truth ─────────────
// Used by:
//   - Employer Portal: HealthCues Team display + Messages "talk to" buttons
//   - Internal CRM: AM picker, message sender role mapping
//
// Each support contact has a stable `id` that doubles as the message
// `recipientId` so messages can be filtered into per-person threads even when
// the contact isn't a real user account in the auth system.
import { C } from './styles';

export const SUPPORT_TEAM = [
  {
    id: 'angie_comer',
    name: 'Angie Comer',
    role: 'Director of Operations / Contracts',
    email: 'a.comer@healthcues.com',
    phone: '864.809.9431',
    color: C.accent,
  },
  {
    id: 'cassie_nix',
    name: 'Cassie Nix',
    role: 'Director of Operations / Payroll',
    email: 'c.nix@healthcues.com',
    phone: '678.522.9988',
    color: C.green,
  },
  {
    id: 'kate_hawn',
    name: 'Kate Hawn',
    role: 'Director of Enrollment',
    email: 'k.hawn@healthcues.com',
    phone: '858.336.4976',
    color: C.purple,
  },
];

export const SUPPORT_TEAM_BY_ID = SUPPORT_TEAM.reduce((acc, m) => {
  acc[m.id] = m;
  return acc;
}, {});

// Conversation thread identifier used by the Account Manager card. The AM is
// resolved per-client (not a fixed person) so we use a sentinel `account_manager`
// recipientId for messages directed to whoever happens to be assigned.
export const RECIPIENT_ACCOUNT_MANAGER = 'account_manager';
